export default "__VITE_ASSET__2a66b1ca__"